import { GridContainer } from './styles';

export default function TeaserGrid({ children }) {
  return <GridContainer>{children}</GridContainer>;
}
